import React from "react";
import { getGraphNode } from "../selectors";
import Helmet from "react-helmet";

import ReactMarkdown from "react-markdown";
import NavBar from "../components/NavBar";
import { H3 } from "../components/typography";

import Section from "../components/blocks/Section";
import Pad from "../components/blocks/Pad";
import Spacer from "../components/blocks/Spacer";
import Background from "../components/blocks/Background";
import { PostBody } from "../components/Post";
import favicon from "../../assets/logofavcon@2x.png";

const PrivacyBody = PostBody.extend`
  h2 {
    margin-left: -1.5rem;
    font-size: 1.5rem;
    padding-top: .5rem;
    padding-bottom: 1.5rem;
  }
`;

export default ({ data }) => {
  const content = getGraphNode(data, "Legal");
  return (
    <div>
      <Helmet
        title="Contraline Privacy"
        meta={[{ name: "Contraline", content: "Privacy" }]}
      >
        <link rel="icon" type="image/png" href={favicon} />
      </Helmet>
      <NavBar color="dark" background="white" />
      <Background color="white" fixed={true}>
        <Section noBorder fixed={true} vPad={false}>
          <Spacer span={2} />
          <Pad h={2}>
            <Pad h={5} v={1}>
              <H3>Privacy Policy</H3>
            </Pad>
            <PrivacyBody>
              <ReactMarkdown source={content.privacyPolicy.privacyPolicy} />
            </PrivacyBody>
          </Pad>
          <Spacer span={2} />
        </Section>
      </Background>
    </div>
  );
};

export const pageQuery = graphql`
  query PrivacyQuery {
    allContentfulLegal {
      edges {
        node {
          id
          privacyPolicy {
            id
            privacyPolicy
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/privacy.js